export default {"src":"/_next/static/media/orange-slice.e98d1d20.svg","height":28,"width":28};